/**
 * Calculates the duration of a storyboard by finding the end time of the last item
 *
 * @param {object} itemEntities an object of item entities
 * @returns {number} Returns the total duration
 */
export default function getStoryboardDuration(itemEntities = {}) {
  return Object.values(itemEntities).reduce((max, item) => {
    const { startTime = 0, duration = 0 } = item || {};
    const endTime = startTime + duration;
    return endTime > max ? endTime : max;
  }, 0);
}
